import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, LabelList, ResponsiveContainer, Rectangle, ReferenceLine, Label } from 'recharts';
import { chartContainer } from './Chart.module.css';

const MediaChart = ({
    media = [{ name: 'Média da Equipe', value: 100, amt: 80 }],
    barHeight = 100,
    chartHeight = 100
}) => {
    const [containerWidth, setContainerWidth] = useState(600);
    const [containerHeight, setContainerHeight] = useState(300);

    useEffect(() => {
        const handleResize = () => {
            const container = document.querySelector(`.${chartContainer}`);

            // console.log('offsetWidth', container.offsetWidth)
            // console.log('offsetHeight', container.offsetHeight)

            if (container) {
                setContainerWidth(container.offsetWidth);
                setContainerHeight(container.offsetHeight);
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const renderCustomLabelMedia = (props) => {
        const { x, y, width, height, value } = props;
        const textColor = 'white'//value > 41 ? 'white' : '#000';
        return (
            <text x={x + width / 2} y={y + height / 2} dy={5} fill={textColor} textAnchor="middle" font-weight="bold">
                Média da equipe: {value.toFixed(1)}
            </text>
        );
    };

    

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip" style={{ backgroundColor: '#fff', borderRadius: 5, padding: '10px', border: '1px solid #ccc' }}>
                    <p className="label">{label}</p>
                    <p className="value">{`Pontuação: ${payload[0].value}`}</p>
                    {/* Customize further as needed */}
                </div>
            );
        }

        return null;
    };


    const getColor = (value) => {
        let red, green;
        const normalizedValue = Math.max(0, Math.min(100, value)) / 100;
        // console.log('normalizedValue: ', normalizedValue)
        // if (normalizedValue < 0.5) {
        //     const ratio = normalizedValue / 0.5;
        //     red = 255;
        //     green = 165 * (ratio);
        // } else {
        //     const ratio = (normalizedValue - 0.5) / 0.5;
        //     red = 255 * (1 - (ratio - 0.3));
        //     green = 165;
        // }
        switch (true) {
            case (normalizedValue <= 1 && normalizedValue > 0.8):
                red = 0
                green = 160
                break;
            case (normalizedValue <= 0.8 && normalizedValue > 0.6):
                red = 255
                green = 160
                break;
            case (normalizedValue <= 0.6 && normalizedValue > 0.4):
                red = 255
                green = 120
                break;
            case (normalizedValue <= 0.4 && normalizedValue > 0.2):
                red = 255
                green = 80
                break;
            case (normalizedValue <= 0.2):
                red = 255
                green = 0
                break;

            default:
                red = 0
                green = 160
                break;
        }

        return `rgb(${red}, ${green}, 0)`;
    };





    return (
        <div
            // className={chartContainer}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: chartHeight,
                zIndex: 5
            }}
        >
            {media &&
                <ResponsiveContainer
                    width="100%"
                    height={chartHeight || 50}
                >
                    <BarChart
                        data={media}
                        layout="vertical"
                        margin={{ top: 20, right: 30, left: -30, bottom: 5 }}
                    >
                        <XAxis type="number" domain={[0, 100]}  tickFormatter={() => ""} stroke="none" />
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            dataKey="name"
                            type="category"
                            tickFormatter={() => ""}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        
                        <Bar
                            radius={[5, 5, 5, 5]}
                            dataKey="value"
                            barSize={barHeight || 50}
                            background={{ fill: '#eee' }}
                        >
                            {media.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={getColor(entry.value)} />
                            ))}
                            <LabelList dataKey="value" content={renderCustomLabelMedia} />
                        </Bar>

                        <ReferenceLine x={80} stroke="#ff0000" strokeWidth={2}>
                            <Label value="Limite: 80" position="insideTopRight" fill="#ffffff" fontSize="12" />
                        </ReferenceLine>
                    </BarChart>
                </ResponsiveContainer>
            }
        </div>
    );
};

export default MediaChart;
